import React, { useCallback, useEffect, useState } from 'react'
import UserLayout from '../layouts/UserLayout'
import { Box, Card, CardContent, CircularProgress, Divider, Typography } from '@mui/material'
import { transformDetailWithPhone } from '../utils/transformDetail'
import { useNavigate, useParams } from 'react-router-dom'
import { DOMAIN } from '../utils/api'
import { handleError } from '../utils/error'
import axios from 'axios'
import { getFromStorage } from '../utils/storage'
import { currentUserActions } from '../redux/store'
import { useDispatch } from 'react-redux'
import { mainGreen, mainRed } from '../utils/color'

export default function SearchDeletedDetail() {
	const dispatch = useDispatch()
	const { orderId } = useParams()
	const navigate = useNavigate()
	const token = getFromStorage('current-user')?.accessToken
	const [searchDetail, setSearchDetail] = useState()
	const [loadingDetail, setLoadingDetail] = useState(true)

	const getSearchDetail = useCallback(
		async function () {
			setLoadingDetail(true)
			const url = `${DOMAIN}/user/search/deleted-detail/${orderId}`
			try {
				const response = await axios({
					url,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setSearchDetail(response.data)
				setLoadingDetail(false)
			} catch (error) {
				handleError(error)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[token, navigate, orderId, dispatch],
	)

	useEffect(() => {
		getSearchDetail()
	}, [getSearchDetail])

	return (
		<UserLayout>
			{loadingDetail ? (
				<Box display='flex' justifyContent='center' sx={{ marginTop: '120px' }}>
					<CircularProgress sx={{ color: mainGreen }} />
				</Box>
			) : (
				<Box sx={{ maxWidth: 992, margin: '0 auto' }}>
					<Card
						sx={{
							padding: '20px 20px 10px 20px',
							background: '#fff',
						}}>
						<CardContent sx={{ pl: 0, pr: 0 }}>
							<Typography
								sx={{
									background: mainRed,
									color: '#fff',
									padding: '0 10px',
									display: 'inline-block',
									borderRadius: '5px',
									mb: 1,
								}}>
								<b>Người xóa: </b>
								{searchDetail?.order?.deletor?.name}
							</Typography>
							<Typography>
								<b>Thời gian xóa: </b>
								{searchDetail?.order?.timeStamp}
							</Typography>
							<Divider sx={{ mb: 1, mt: 1 }} />
							<Typography>
								<b>Ca: </b>
								{searchDetail?.order?.orderData?.shiftCode}
								{searchDetail?.order?.orderData?.shiftIndex} - {searchDetail?.order?.orderData?.shiftDay}
							</Typography>
							<Typography>
								<b>Khối lượng: </b>
								{searchDetail?.order?.orderData?.quantity}kg
							</Typography>
							<Typography>
								<b>Tiền: </b>
								{searchDetail?.order?.orderData?.totalPrice.toLocaleString()}đ
							</Typography>
							<Typography>
								<b>Thông tin: </b>
								{searchDetail?.order?.orderData?.detail && (
									<span
										dangerouslySetInnerHTML={{
											__html: transformDetailWithPhone(searchDetail?.order?.orderData?.detail),
										}}></span>
								)}
							</Typography>
							<Divider sx={{ mb: 1, mt: 1 }} />
							<Typography>
								<b>Người tạo: </b>
								{searchDetail?.creator?.name}
							</Typography>
							<Typography>
								<b>Thời gian tạo: </b>
								{searchDetail?.order?.orderData?.creator?.createdAt}
							</Typography>
							<Divider sx={{ mb: 1, mt: 1 }} />
							<Typography>
								<b>Người xử lý: </b>
								{searchDetail?.producer?.name || 'chưa có'}
							</Typography>
							<Typography>
								<b>Nhận xử lý: </b>
								{searchDetail?.order?.orderData?.producer?.produceStart || 'chưa có'}
							</Typography>
							<Typography>
								<b>Hoàn thành xử lý: </b>
								{searchDetail?.order?.orderData?.producer?.produceEnd || 'chưa có'}
							</Typography>
							<Divider sx={{ mb: 1, mt: 1 }} />

							<Typography>
								<b>Người giao hàng: </b>
								{searchDetail?.shipper?.name || 'chưa có'}
							</Typography>
							<Typography>
								<b>Nhận giao hàng: </b>
								{searchDetail?.order?.orderData?.shipper?.shipStart || 'chưa có'}
							</Typography>
						</CardContent>
					</Card>
				</Box>
			)}
		</UserLayout>
	)
}
